if (typeof require !== 'undefined') {
    var autocomplete = require('autocompleter');
}

$(function () {

    function getProjectsWidgetCard(inputEl) {
        // tik jei input yra .projects_widget viduje
        if (!$(inputEl).closest('.projects_widget').length) return null;

        var $card = $(inputEl).closest('.card');
        return $card.length ? $card : null;
    }

    function setAutocompleteActive(inputEl, isActive) {
        var $card = getProjectsWidgetCard(inputEl);
        if (!$card) return;

        $card.toggleClass('active-autocomplete', !!isActive);
    }

    // clear mygtukas tik projects_widget viduje ===
    function ensureClearBtn(input) {
        if (!$(input).closest('.projects_widget').length) return null;

        var $existing = $(input).siblings('.js-ac-clear');
        if ($existing.length) return $existing;

        var $btn = $('<button type="button" class="js-ac-clear" aria-label="Clear"><i class="ph-fill ph-x-circle"></i></button>');
        $(input).after($btn);

        $btn.on('mousedown', function (e) { e.preventDefault(); });

        $btn.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            input.value = '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
            $(input).trigger('keyup');
            setAutocompleteActive(input, false);
            toggleClearBtn(input);
            input.focus();
        });

        return $btn;
    }

    function toggleClearBtn(input) {
        var $btn = ensureClearBtn(input);
        if (!$btn) return;
        $btn.toggle(!!input.value);
    }

    $('input.cms-autocomplete').each(function (index, input) {
        var method = $(input).data('method');
        var jContainer = $(input).closest('form').find('.autocomplete-container');

        toggleClearBtn(input);
        $(input).on('input keyup change', function () {
            toggleClearBtn(input);
        });

        $(input).on('focus', function () {
            setAutocompleteActive(input, true);
            toggleClearBtn(input);
        });

        $(input).on('blur', function () {
            setTimeout(function () {
                if (document.activeElement !== input) {
                    setAutocompleteActive(input, false);
                }
            }, 120);
        });

        var instance = new autocomplete({
            input: input,

            fetch: function (text, update) {
                $.getJSON(method, { query: text }, function (data) {
                    update(data);
                });
            },

            render: function (item, currentValue, index) {
                const itemElement = document.createElement('div');

                const icon = document.createElement('em');
                icon.className = item.icon || 'ph ph-arrow-circle-right';

                const link = document.createElement('a');
                link.setAttribute('href', item.link);

                const text = document.createElement('span');
                text.className = 'link-text';

                const safeValue = currentValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp('(' + safeValue + ')', 'ig');
                text.innerHTML = item.title.replace(regex, '<strong>$1</strong>');

                link.append(icon, text);

                if (item.muted_text) {
                    const mutedText = document.createElement('span');
                    mutedText.className = 'fs-14 text-muted ms-auto fw-light';
                    mutedText.textContent = item.muted_text;

                    link.append(mutedText);
                }

                itemElement.append(link);

                return itemElement;
            },

            onSelect: function (item) {
                setAutocompleteActive(input, false);
                window.location = item.link;
            },

            container: jContainer.length ? jContainer.get(0) : null,

            customize: function (input, inputRect, container, maxHeight) {
                setAutocompleteActive(input, true);
                toggleClearBtn(input);

                if (jContainer.length) {
                    container.style = '';

                    let btnText = document.createElement('strong');
                    btnText.innerHTML =
                        jContainer.data('btn-text') + ': <span>"' + input.value + '"</span>';

                    let btn = document.createElement('button');
                    btn.setAttribute('type', 'button');
                    btn.className = 'd-block w-100 btn btn-primary mt-3';
                    btn.addEventListener('click', function () {
                        $(input).closest('form').submit();
                    });
                    btn.appendChild(btnText);
                    container.appendChild(btn);
                }
            },

            disableAutoSelect: true,
            debounceWaitMs: 500
        });
    });
});
